/* Option A: cart truth, not a saved picker, owns the sample count. */
(function (global) {
  'use strict';
  function samples(cart) {
    return (cart.items || []).filter(function (line) {
      return /^a4\s+sample$/i.test(line.variant_title || '') && line.handle !== 'six-sample-box';
    });
  }
  function count(cart) { return samples(cart).reduce(function (n, line) { return n + line.quantity; }, 0); }
  function progress(n) {
    var boxes = Math.floor(n / 6), rest = n % 6;
    return (boxes ? (boxes === 1 ? 'Box 1 full' : boxes + ' boxes full') : '') +
      (rest ? (boxes ? ' · Box ' + (boxes + 1) + ': ' : '') + rest + ' of 6' : '');
  }
  function completed(before, after) { return Math.floor(after / 6) > Math.floor(before / 6); }
  function sampleName(line) { return (line.product_title || 'A4 sample').replace(/ Vinyl Wrap(?: Contact Paper)?$/, ''); }
  var api = { samples: samples, count: count, progress: progress, completed: completed };
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  var root = ((global.theme && global.theme.routes && global.theme.routes.root_url) || '/').replace(/\/$/, '');
  var cached = null, pending = null, removing = false, revision = 0, inFlight = null;
  var seed = document.querySelector('[data-sample-cart-data]');
  try { cached = seed ? JSON.parse(seed.getAttribute('data-cart')) : null; } catch (error) {}
  function invalidate() { revision++; }
  function read() {
    var requestedAt = revision;
    if (inFlight && inFlight.revision === requestedAt) return inFlight.promise;
    var request = fetch(root + '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .then(function (cart) {
        if (pending) return pending.cart;
        if (requestedAt !== revision) return read();
        cached = cart;
        return cart;
      });
    inFlight = { revision: requestedAt, promise: request };
    request.then(clear, clear);
    function clear() { if (inFlight && inFlight.promise === request) inFlight = null; }
    return request;
  }
  function beginAdd(line) {
    var before = cached || { items: [] };
    revision++;
    pending = { before: before, cart: { items: [line].concat(before.items || []), optimistic: true } };
    render(pending.cart, { isRoll: false });
    return count(before);
  }
  function finishAdd(accepted) {
    if (!pending) return;
    cached = accepted ? pending.cart : pending.before;
    pending = null;
    revision++;
    render(cached, { isRoll: false });
    return cached;
  }
  function showName(el, name) {
    var strong = document.createElement('strong'); strong.textContent = name;
    el.replaceChildren(strong);
  }

  function render(cart, options) {
    options = options || {};
    if (options.isRoll == null) {
      var selection = document.querySelector('[data-sheet-sizes] input:checked');
      options.isRoll = !!selection && selection.dataset.sizeKey !== 'a4';
    }
    if (pending) cart = pending.cart;
    var lines = samples(cart), n = count(cart), rest = n % 6;
    document.querySelectorAll('[data-sample-cart-progress]').forEach(function (el) {
      el.hidden = !n || options.isRoll;
      var focused = document.activeElement;
      var focusedName = focused && el.contains(focused) && focused.getAttribute('data-sample-name');
      var focusedRemove = focused && el.contains(focused) && focused.classList.contains('vmcm-sample-progress__remove') && focused.getAttribute('aria-label');
      var selectedName = el.getAttribute('data-selected-sample');
      var openBoxes = Array.from(el.querySelectorAll('details')).map(function (box) { return box.open; });
      el.replaceChildren();
      if (!n || options.isRoll) return;
      var text = document.createElement('p'); text.textContent = progress(n); el.appendChild(text);
      var units = [];
      lines.forEach(function (line) { for (var i = 0; i < line.quantity; i++) units.push(line); });
      var slots = document.createElement('div'); slots.className = 'vmcm-sample-progress__slots';
      var recent = rest ? units.slice(n - rest) : units.slice(-6);
      var selectedIndex = recent.findIndex(function (line) { return sampleName(line) === selectedName; });
      var selected = document.createElement('p');
      selected.setAttribute('role', 'status'); selected.setAttribute('data-sample-slot-name', '');
      selected.hidden = selectedIndex < 0;
      if (selectedIndex >= 0) showName(selected, selectedName);
      else el.removeAttribute('data-selected-sample');
      for (var j = 0; j < 6; j++) {
        var line = recent[j];
        var slot = document.createElement(line ? 'button' : 'span'); slot.className = 'vmcm-sample-progress__slot';
        slot.classList.toggle('is-filled', !!line);
        if (line) {
          slot.type = 'button';
          slot.setAttribute('data-sample-name', sampleName(line));
          slot.setAttribute('aria-label', 'Identify sample ' + (j + 1) + ': ' + sampleName(line));
          slot.setAttribute('aria-pressed', j === selectedIndex ? 'true' : 'false');
          slot.addEventListener('click', function () {
            slots.querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-pressed', 'false'); });
            this.setAttribute('aria-pressed', 'true');
            el.setAttribute('data-selected-sample', this.getAttribute('data-sample-name'));
            showName(selected, this.getAttribute('data-sample-name'));
            selected.hidden = false;
          });
        } else {
          slot.setAttribute('role', 'img'); slot.setAttribute('aria-label', 'Empty sample slot');
        }
        if (line && line.image) { var img = document.createElement('img'); img.src = line.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2'); img.alt = ''; slot.appendChild(img); }
        slots.appendChild(slot);
      }
      el.appendChild(slots); el.appendChild(selected);
      if (focusedName) {
        var focusTarget = Array.from(slots.querySelectorAll('button')).find(function (button) { return button.getAttribute('data-sample-name') === focusedName; }) || slots.querySelector('button');
        if (focusTarget && focusTarget.focus) focusTarget.focus();
      }
      function names(group) {
        var list = document.createElement('ul'); list.className = 'vmcm-sample-progress__names';
        group.forEach(function (item) {
          var name = document.createElement('li');
          var label = document.createElement('span'); label.textContent = sampleName(item); name.appendChild(label);
          var remove = document.createElement('button'); remove.type = 'button'; remove.className = 'vmcm-sample-progress__remove';
          remove.textContent = 'Remove'; remove.setAttribute('aria-label', 'Remove one ' + sampleName(item) + ' sample');
          remove.disabled = removing || !!cart.optimistic;
          remove.addEventListener('click', function () { removeOne(item, el); });
          name.appendChild(remove);
          list.appendChild(name);
        });
        return list;
      }
      el.appendChild(names(recent));
      for (var start = 0; start < n - recent.length; start += 6) {
        var box = document.createElement('details'); box.open = !!openBoxes[start / 6];
        var label = document.createElement('summary'); label.textContent = 'Box ' + (start / 6 + 1) + ' full · See samples';
        box.appendChild(label); box.appendChild(names(units.slice(start, start + 6))); el.appendChild(box);
      }
      var note = document.createElement('p');
      note.textContent = nudge(cart);
      el.appendChild(note);
      if (focusedRemove) {
        var removes = Array.from(el.querySelectorAll('.vmcm-sample-progress__remove'));
        var again = removes.find(function (button) { return button.getAttribute('aria-label') === focusedRemove; }) || removes[0];
        if (again && again.focus) again.focus();
      }
    });
    if (options.added) {
      var checkout = document.querySelector('[data-sheet-checkout]');
      var hasPreorder = (cart.items || []).some(function (line) { return line.properties && line.properties[(global.VELVEN_PREORDER && global.VELVEN_PREORDER.key) || 'Preorder']; });
      if (checkout) checkout.setAttribute('href', root + (options.isRoll || hasPreorder || options.confirmed === false ? '/cart' : '/checkout'));
      var message = document.querySelector('[data-sheet-donemsg]');
      if (message) message.textContent = !options.isRoll && completed(options.before || 0, n)
        ? (Math.floor(n / 6) === 1 ? 'Your Sample Box is ready' : Math.floor(n / 6) + ' Sample Boxes are ready') : 'Added to your bag.';
    }
    return cart;
  }
  // Same cart write as the cart page's Remove; the modal re-renders in place instead of reloading.
  function removeOne(line, el) {
    if (removing || pending || (cached && cached.optimistic)) return;
    removing = true;
    el.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    var message = document.querySelector('[data-sheet-donemsg]');
    fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key || String(line.variant_id), quantity: line.quantity - 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('Remove failed'); return r.json(); })
      .then(function (cart) {
        invalidate(); cached = cart;
        removing = false;
        render(cart);
        if (message) message.textContent = 'Removed ' + sampleName(line) + ' from your bag.';
        document.dispatchEvent(new global.CustomEvent('cart:refresh'));
        var next = el.querySelector('.vmcm-sample-progress__remove') || document.querySelector('[data-sheet-viewbag]');
        if (next && next.focus) next.focus();
      })
      .catch(function () {
        invalidate();
        read().catch(function () { return cached || { items: [] }; }).then(function (cart) {
          removing = false;
          render(cart);
        });
        if (message) message.textContent = 'Could not remove that sample. Try again.';
      });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function hasBoxPrice(cart) {
    return samples(cart).some(function (line) { return (line.line_level_discount_allocations || []).some(function (a) { return a.discount_application && a.discount_application.title === 'Sample Box price'; }); });
  }
  function nudge(cart) {
    var n = count(cart), rest = n % 6;
    if (!rest) return 'Keep exploring or review your samples. Samples ship free.';
    var next = (Math.floor(n / 6) + 1) * 2995;
    var subtotal = samples(cart).reduce(function (sum, line) { return sum + line.final_line_price; }, 0);
    // Before activation do not promise a price the checkout cannot yet give.
    if (cart.optimistic || !hasBoxPrice(cart)) return 'Add ' + (6 - rest) + ' more to complete the next box. Samples ship free.';
    return 'Add ' + (6 - rest) + ' more for ' + (Math.floor(n / 6) + 1) + (n < 6 ? ' box at ' : ' boxes at ') + money(next) + (subtotal > next ? ' — ' + money(subtotal - next) + ' less.' : '.') + ' Before any discount code.';
  }
  function groupCart(cart) {
    var list = document.querySelector('.vmcm-cart__items');
    if (!list) return;
    list.querySelectorAll('.vmcm-sample-cart-box').forEach(function (el) { el.remove(); });
    var units = [], boxSaving = 0;
    samples(cart).forEach(function (line) {
      var original = Array.from(list.querySelectorAll('[data-line-key]')).find(function (el) { return el.dataset.lineKey === line.key; });
      if (!original) return;
      original.hidden = true;
      var lineBox = (line.line_level_discount_allocations || []).reduce(function (sum, a) { return sum + (a.discount_application && a.discount_application.title === 'Sample Box price' ? a.amount : 0); }, 0);
      boxSaving += lineBox;
      var otherSaving = line.original_line_price - line.final_line_price - lineBox;
      for (var i = 0; i < line.quantity; i++) {
        var other = Math.floor(otherSaving * (i + 1) / line.quantity) - Math.floor(otherSaving * i / line.quantity);
        units.push({ line: line, cents: line.original_price - other });
      }
    });
    // Shopify may allocate the box saving to any units; the boxes share it, extras stay at retail.
    var fullBoxes = Math.floor(units.length / 6);
    for (var start = 0; start < units.length; start += 6) {
      var group = units.slice(start, start + 6), full = group.length === 6, k = start / 6;
      var block = document.createElement('li'); block.className = 'vmcm-sample-cart-box';
      var heading = document.createElement('h2'); heading.textContent = full ? 'Sample Box ' + (k + 1) + ' · 6 samples' : 'Extra A4 samples · ' + group.length + ' of 6';
      block.appendChild(heading);
      var share = full && boxSaving ? Math.floor(boxSaving * (k + 1) / fullBoxes) - Math.floor(boxSaving * k / fullBoxes) : 0;
      var total = group.reduce(function (sum, unit) { return sum + unit.cents; }, 0) - share;
      var retail = group.reduce(function (sum, unit) { return sum + unit.line.original_price; }, 0);
      var price = document.createElement('p');
      // Strike retail only when Shopify actually priced the full box lower; never promise an inactive offer.
      if (share > 0) {
        var was = document.createElement('s'); was.className = 'vmcm-sample-cart-box__was';
        var wasLabel = document.createElement('span'); wasLabel.className = 'vmcm-sr'; wasLabel.textContent = 'was ';
        was.append(wasLabel, money(retail));
        var now = document.createElement('strong'); now.textContent = money(total);
        price.append(now, ' ', was);
      } else price.textContent = money(total) + ' · before any order discount code';
      block.appendChild(price);
      group.forEach(function (unit) {
        var line = unit.line, row = document.createElement('div'); row.className = 'vmcm-sample-cart-box__finish';
        if (line.image) { var img = document.createElement('img'); img.src = line.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2'); img.alt = ''; img.width = 48; img.height = 48; row.appendChild(img); }
        var name = document.createElement('span'); name.textContent = line.product_title; row.appendChild(name);
        var remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', 'Remove one ' + line.product_title + ' sample');
        remove.addEventListener('click', function () {
          list.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity - 1 }) })
            .then(function (r) { if (!r.ok) throw new Error('Remove failed'); global.location.reload(); })
            .catch(function () { list.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); remove.textContent = 'Try removing again'; });
        });
        row.appendChild(remove); block.appendChild(row);
      });
      list.appendChild(block);
    }
    if (units.length) {
      var note = document.createElement('li'); note.className = 'vmcm-sample-cart-box';
      note.textContent = progress(units.length) + '. ' + nudge(cart);
      list.appendChild(note);
    }
  }
  api.read = read; api.render = render; api.beginAdd = beginAdd; api.finishAdd = finishAdd; api.invalidate = invalidate;
  api.isRemoving = function () { return removing; };
  global.VelvenSampleProgress = api;
  if (cached) render(cached);
  read().then(function (cart) { render(cart); groupCart(cart); }).catch(function () {});
  document.addEventListener('velven:cart-add', invalidate);
  document.addEventListener('cart:refresh', function () { invalidate(); read().then(function (cart) { render(cart); }).catch(function () {}); });
  var cartPage = document.querySelector('[data-cart-page]');
  if (cartPage && global.MutationObserver) new global.MutationObserver(function (records) {
    var replaced = records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && node.matches('[data-cart]'); }); });
    if (replaced) {
      invalidate();
      read().then(function (cart) { render(cart); groupCart(cart); }).catch(function () {});
    }
  }).observe(cartPage, { childList: true, subtree: true });
})(typeof window !== 'undefined' ? window : this);
